export const TERMS_LINK = 'https://cookiewow.com/terms'
export const PRIVACY_LINK = 'https://cookiewow.com/privacy'
export const CREATE_COOKIE_POLICY_LINK =
  'https://pdpa.pro/create/policy?template=cookie'

export const NDATA_SALES_EMAIL = 'sales@datawow.io'
export const QUOTATION_URL = 'https://quotation.datawow.io/'
export const PHONE_HREF = '02-024-5560'
export const REFERRAL_FORM = 'https://cookiewow.com/referral#registration'
